import React from 'react'
import { deleteKeys, generateId } from '@ztechapps/common.utils'
import { templateQueries, useMutation } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'

export const CloneContextMenuItem = ({ template }) => {
  const [onCreate, , { loading }] = useMutation({
    query: templateQueries.createConfig.query,
    options: { mutationOptions: { refetchQueries: ['singleTemplate', 'allTemplate'] } },
  })

  const onClick = async (e) => {
    e?.preventDefault()

    const input = deleteKeys(template, ['_config', '__typename', '_id'])
    input.name = `${input.name}_Cloned_${generateId(3)}`
    await onCreate({ input })
  }

  return <BusyButtonLink onClick={onClick} icon="copy" title="Clone this template." isBusy={loading} />
}
